import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { AddLeaderDialog, DeleteLeaderDialog } from './index'
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import SwipeableViews from 'react-swipeable-views';
import Grid from '@material-ui/core/Grid';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import IconButton from '@material-ui/core/IconButton';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Link from '@material-ui/core/Link';
import PersonAdd from '@material-ui/icons/PersonAdd';
import TextField from '@material-ui/core/TextField';
import { Scrollbars } from 'react-custom-scrollbars';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Fab from '@material-ui/core/Fab';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import 'date-fns';
import deLocale from 'date-fns/locale/de';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';
import yellow from '@material-ui/core/colors/yellow';
import ErrorIcon from '@material-ui/icons/Error';
import CloseIcon from '@material-ui/icons/Close';
import PublishIcon from '@material-ui/icons/Public';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import deepOrange from '@material-ui/core/colors/deepOrange';
import request from 'superagent'
import moment from 'moment';
import * as Constants from '../constants'

const styles = theme => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    position: "absolute",
    width: 125,
    right: 60,
    color: theme.palette.text.secondary,
  },
  terciaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    position: "absolute",
    right: 155,
    width: 50,
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  icon: {
    fontSize: 20,
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});

class AdministrationAdmin extends React.Component {
  state = {
    expanded: 0,
    selected_tab: 0,
    snackbar_error_open: false,
    snackbar_message: "",
    loading: false,
    anchorEl: null,
    dialog_add_child_open: false,
    dialog_edit_child_open: false,
    dialog_remove_child_open: false,
    dialog_first_program_info_open: false,
    dialog_create_leader_open: false,
    all_program_data: [],
    program_data: [],
    leader_data: [],
    selected_program_data: [],
    children_data: [],
    selected_child: null,
    selected_leader: null,

    //Administrator
    publishing: false,
    new_state: 0,
    new_app_state: 0,
  }

  constructor(props) {
    super(props)

    //Alle Programme laden
    this.loadAllPrograms()
    this.loadAllLeaders()
    this.loadChildren()
  }

  loadChildren = () => {
    let currentComponent = this;
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .send({ command: "getchildren", parent_id: this.props.userData.id })
      .end(function (err, res) {
        var result = res.text.trim();
        var obj = JSON.parse(result);
        if (currentComponent.state.selected_child !== null) {
          var new_child = currentComponent.state.selected_child;
          for (const [index, child] of obj.entries()) {
            if (new_child.id === child.id) {
              new_child = child;
              break;
            }
          }
          currentComponent.setState({ children_data: obj, selected_child: new_child });
          currentComponent.onSelectChild(new_child);
        } else {
          currentComponent.setState({ children_data: obj });
        }
      });
  }

  loadAllPrograms = () => {
    let currentComponent = this;
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .send({ command: "getallprograms" })
      .end(function (err, res) {
        var result = res.text.trim();
        var obj = JSON.parse(result);
        currentComponent.setState({ all_program_data: obj, program_data: obj });
      });
  }

  loadAllLeaders = () => {
    let currentComponent = this;
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .send({ command: "getallleaders" })
      .end(function (err, res) {
        var result = res.text.trim();
        var obj = JSON.parse(result);
        currentComponent.setState({ leader_data: obj });
      });
  }

  handleTabChange = (event, value) => {
    this.setState({ selected_tab: value });
  };

  handleTabChangeIndex = index => {
    this.setState({ selected_tab: index });
  };

  onSelectChild = child => {
    this.setState({ selected_child: child });
    this.loadWishlist(child);
  }

  getProgramsForChild = child => {
    //Programme für ausgewähltes Kind filtern
    var program_data = [];
    for (const [index, program] of this.state.all_program_data.entries()) {
      var max_date = new Date(new Date().getFullYear() - program.age_min, 9, 1); // 01.10.
      var min_date = new Date(new Date().getFullYear() - (program.age_max === "0" ? 99 : program.age_max) - 1, 5, 30); // 30.06.
      var dob = moment(child.dob, 'DD.MM.YYYY');
      if (dob > min_date && dob < max_date) program_data.push(program);
    }
    return program_data;
  }

  addChild = (show_dialog) => {
    this.setState({ dialog_add_child_open: show_dialog });
  }

  onChildAdded = () => {
    this.setState({ dialog_add_child_open: false });
    this.loadChildren();
  }

  editChild = (show_dialog) => {
    this.setState({ dialog_edit_child_open: show_dialog });
  }

  onChildEdited = () => {
    this.setState({ dialog_edit_child_open: false });
    this.loadChildren();
  }

  openMenu = (event, child) => {
    this.setState({ anchorEl: event.currentTarget, selected_child: child });
  }

  handleMenuClose = item_id => {
    if (item_id === 0) {
      this.setState({ anchorEl: null });
    } else if (item_id === 1) {
      this.setState({ anchorEl: null, dialog_edit_child_open: true });
    } else if (item_id === 2) {
      this.setState({ anchorEl: null, dialog_remove_child_open: true });
    }
  }

  onChildRemoved = () => {
    this.setState({ dialog_remove_child_open: false, selected_child: null, selected_program_data: [], program_data: this.state.all_program_data });
    this.loadChildren();
  }

  onChildRemoveCanceled = () => {
    this.setState({ dialog_remove_child_open: false });
  }

  onFirstProgramInfoClosed = () => {
    this.setState({ dialog_first_program_info_open: false });
  }

  loadWishlist = child => {
    let currentComponent = this;
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .send({ command: "getwishlist", child_id: child.id })
      .end(function (err, res) {
        var result = res.text.trim();
        var registrations = JSON.parse(result);
        var selected_program_data = [];
        var new_program_data = [];
        var price = 0;
        for (const [index1, program] of currentComponent.getProgramsForChild(child).entries()) {
          var existing = false;
          for (const [index2, registration] of registrations.entries()) {
            if (program.id === registration.program_id) {
              program.accepted = registration.accepted;
              selected_program_data.push(program);
              price = price + parseFloat(program.price);
              existing = true;
            }
          }
          if (!existing && (currentComponent.props.server_settings.state < 4 || (program.current_participants < program.participants - 2))) new_program_data.push(program);
        }
        for (const [index, other_child] of currentComponent.state.children_data.entries()) {
          if (other_child.id === child.id) {
            currentComponent.state.children_data[index].registrations = selected_program_data.length;
            currentComponent.state.children_data[index].price = price;
            break;
          }
        }
        currentComponent.setState({ selected_program_data: selected_program_data, program_data: new_program_data, loading: false });
      });
  }

  addToWishlist = (program_id, priority) => {
    this.setState({ loading: true });
    let currentComponent = this;
    if (this.state.selected_program_data.length === 0) this.setState({ dialog_first_program_info_open: true });
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .send({ command: "addtowishlist", child_id: this.state.selected_child.id, program_id: program_id, accepted: (this.props.server_settings.state === 4 ? "E" : "J"), priority: priority })
      .end(function (err, res) {
        var result = res.text.trim();
        if (result === "1") {
          currentComponent.loadWishlist(currentComponent.state.selected_child);
        } else {
          currentComponent.setState({ snackbar_message: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut", snackbar_open: true, loading: false });
        }
      });
  }

  removeFromWishlist = program_id => {
    this.setState({ loading: true });
    let currentComponent = this;
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .send({ command: "removefromwishlist", child_id: this.state.selected_child.id, program_id: program_id })
      .end(function (err, res) {
        var result = res.text.trim();
        if (result === "1") {
          currentComponent.loadWishlist(currentComponent.state.selected_child);
          currentComponent.setState({ expanded: 0 });
        } else {
          currentComponent.setState({ snackbar_message: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut", snackbar_open: true, loading: false });
        }
      });
  }

  handlePanelChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  handleSnackbarClose = () => {
    this.setState({ snackbar_open: false, snackbar_success_open: false });
  }

  getColorForAccepted = accepted => {
    if (parseInt(this.props.server_settings.state) < 4) return "white";
    if (accepted === "J" || accepted === "C") return green[600];
    if (accepted === "E") return yellow[600];
    if (accepted === "L" || accepted === "D") return red[600];
  }

  getColorForParticipants = (current_participants, participants) => {
    if (current_participants >= participants) return red[600];
    if (current_participants >= participants - 2) return yellow[600];
    return green[600];
  }

  changeState = (new_state) => {
    this.setState({ new_state: new_state });
  }

  changeAppState = (new_app_state) => {
    this.setState({ new_app_state: new_app_state });
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };

  handleDateChange = (date, name) => {
    this.setState({ [name]: date });
  }

  hasTimeOverlap = (program) => {
    const a_start = moment(program.date_from + " " + program.time_from, 'DD.MM.YYYY HH:mm').valueOf();
    const a_end = moment((program.date_to === "" ? program.date_from : program.date_to) + " " + (program.time_to === "" ? program.time_from : program.time_to), 'DD.MM.YYYY HH:mm').valueOf();
    for (const [index, selected_program] of this.state.selected_program_data.entries()) {
      var b_start = moment(selected_program.date_from + " " + selected_program.time_from, 'DD.MM.YYYY HH:mm').valueOf();
      var b_end = moment((selected_program.date_to === "" ? selected_program.date_from : selected_program.date_to) + " " + (selected_program.time_to === "" ? selected_program.time_from : selected_program.time_to), 'DD.MM.YYYY HH:mm').valueOf();

      if (a_start <= b_start && b_start < a_end) return selected_program; // b starts in a
      if (a_start < b_end && b_end <= a_end) return selected_program; // b ends in a
      if (b_start < a_start && a_end < b_end) return selected_program; // a in b
    }
    return false;
  }

  hasState4Registrations = () => {
    for (const [index, program] of this.state.selected_program_data.entries()) {
      if (program.accepted === "E") return true;
    }
    return false;
  }

  getState4RegistrationPrice = () => {
    var total_price = 0;
    for (const [index, program] of this.state.selected_program_data.entries()) {
      if (program.accepted === "E") total_price += parseFloat(program.price);
    }
    return total_price;
  }

  finishRegistration = () => {
    this.setState({ sending_bill: true });
    let currentComponent = this;
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .send({ command: "finishregistration", parent_id: this.props.userData.id, child_id: this.state.selected_child.id })
      .end(function (err, res) {
        var result = res.text.trim();
        if (result === "1") {
          currentComponent.setState({ snackbar_message: "Bitte überprüfen Sie Ihr E-Mail Postfach. Evtl. auch den Spam-Ordner.", snackbar_success_open: true, sending_bill: false });
          currentComponent.loadWishlist(currentComponent.state.selected_child);
        } else {
          currentComponent.setState({ snackbar_message: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut", snackbar_open: true, sending_bill: false });
        }
      });
  }

  saveChangings = () => {
    this.setState({ publishing: true });
    var state = this.state.new_state === 0 ? this.props.server_settings.state_right : this.state.new_state;
    var state_app = this.state.new_app_state === 0 ? this.props.server_settings.state_app : this.state.new_app_state;
    var date1 = moment(this.state.date1 === undefined ? moment(this.props.server_settings.date1, 'DD.MM.YYYY') : this.state.date1).format('DD.MM.YYYY');
    var date2 = moment(this.state.date2 === undefined ? moment(this.props.server_settings.date2, 'DD.MM.YYYY') : this.state.date2).format('DD.MM.YYYY');
    var date3 = moment(this.state.date3 === undefined ? moment(this.props.server_settings.date3, 'DD.MM.YYYY') : this.state.date3).format('DD.MM.YYYY');
    var date4 = moment(this.state.date4 === undefined ? moment(this.props.server_settings.date4, 'DD.MM.YYYY') : this.state.date4).format('DD.MM.YYYY');
    var date5 = moment(this.state.date5 === undefined ? moment(this.props.server_settings.date5, 'DD.MM.YYYY') : this.state.date5).format('DD.MM.YYYY');
    var date1_app = moment(this.state.date1_app === undefined ? moment(this.props.server_settings.date1_app, 'DD.MM.YYYY') : this.state.date1_app).format('DD.MM.YYYY');
    var date2_app = moment(this.state.date2_app === undefined ? moment(this.props.server_settings.date2_app, 'DD.MM.YYYY') : this.state.date2_app).format('DD.MM.YYYY');
    var date3_app = moment(this.state.date3_app === undefined ? moment(this.props.server_settings.date3_app, 'DD.MM.YYYY') : this.state.date3_app).format('DD.MM.YYYY');
    var date4_app = moment(this.state.date4_app === undefined ? moment(this.props.server_settings.date4_app, 'DD.MM.YYYY') : this.state.date4_app).format('DD.MM.YYYY');
    var date5_app = moment(this.state.date5_app === undefined ? moment(this.props.server_settings.date5_app, 'DD.MM.YYYY') : this.state.date5_app).format('DD.MM.YYYY');
    var state_1_message = this.state.state_1_message === undefined ? this.props.server_settings.state_1_message : this.state.state_1_message;
    var state_3_message = this.state.state_3_message === undefined ? this.props.server_settings.state_3_message : this.state.state_3_message;
    var state_6_message = this.state.state_6_message === undefined ? this.props.server_settings.state_6_message : this.state.state_6_message;
    var state_app_1_message = this.state.state_app_1_message === undefined ? this.props.server_settings.state_app_1_message : this.state.state_app_1_message;
    var state_app_3_message = this.state.state_app_3_message === undefined ? this.props.server_settings.state_app_3_message : this.state.state_app_3_message;
    var state_app_6_message = this.state.state_app_6_message === undefined ? this.props.server_settings.state_app_6_message : this.state.state_app_6_message;
    var payment_date = moment(this.state.payment_date === undefined ? moment(this.props.server_settings.payment_date, 'DD.MM.YYYY') : this.state.payment_date).format('DD.MM.YYYY');

    let currentComponent = this;
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .send({ command: "changeserversettings", state: state, state_app: state_app, date1: date1, date2: date2, date3: date3, date4: date4, date5: date5, date1_app: date1_app, date2_app: date2_app, date3_app: date3_app, date4_app: date4_app, date5_app: date5_app, state_1_message: state_1_message, state_3_message: state_3_message, state_6_message: state_6_message, state_app_1_message: state_app_1_message, state_app_3_message: state_app_3_message, state_app_6_message: state_app_6_message, payment_date: payment_date })
      .end(function (err, res) {
        var result = res.text.trim();
        if (result === "1") {
          currentComponent.setState({ publishing: false });
        } else {
          currentComponent.setState({ snackbar_message: "Die Änderungen konnten nicht veröffentlicht werden.", snackbar_open: true, publishing: false });
        }
      });
  }

  jumpToProgram = program_id => {
    this.setState({ selected_tab: 0, expanded: program_id });
  }

  createLeader = () => {
    this.setState({ dialog_create_leader_open: true });
  }

  deleteLeader = leader => {
    this.setState({ dialog_delete_leader_open: true, selected_leader: leader });
  }

  onCreatedLeader = result => {
    this.setState({ dialog_create_leader_open: false });
    this.loadAllLeaders();
  }

  onDeletedLeader = result => {
    this.setState({ dialog_delete_leader_open: false });
    this.loadAllLeaders();
  }

  render() {
    const { classes, theme } = this.props;
    console.log(this.props.server_settings);

    return (
      <Fragment>
        {/* Kopfzeile */}
        <div style={{ position: "absolute", width: "100%", height: 26, top: 64, background: deepOrange[400], boxShadow: "0px 3px 5px rgba(0, 0, 0, 0.5)" }}>
          <Typography align="center" color="inherit" variant="subtitle1" style={{ position: "absolute", width: "calc(60%)", left: 0 }} inline>{"Administration"}</Typography>
        </div>
        {/* Administration */}
        {<div style={{ position: "absolute", width: "60%", height: "calc(100% - 130px)", top: 90 }}>
          <div style={{ position: "absolute", top: 0, bottom: 65, left: 0, right: "50.2%", background: "white", opacity: 0.6 }}>
            <Scrollbars style={{ position: "absolute", bottom: 65, top: 0, left: 0, right: 0 }}>
              <div style={{ padding: 20 }}>
                <Typography align="center" variant="h6">{"Web-App"}</Typography>
                <RadioGroup value={this.state.new_state}>
                  <FormControlLabel value={1} control={<Radio checked={this.state.new_state === 0 ? this.props.server_settings.state_right === 1 : this.state.new_state === 1} onClick={() => this.changeState(1)} />} label="Phase 1: Noch nicht aktiviert" />
                  <TextField label="Anzeigetext Phase 1 (<date1> bzw. <date2> als Platzhalter für Datum)" multiline rowsMax="4" defaultValue={this.state.state_1_message === undefined ? this.props.server_settings.state_1_message : this.state.state_1_message} onChange={this.handleChange('state_1_message')} style={{ marginLeft: 33 }} />
                  <FormControlLabel value={2} control={<Radio checked={this.state.new_state === 0 ? this.props.server_settings.state_right === 2 : this.state.new_state === 2} onClick={() => this.changeState(2)} />} label="Phase 2: Erste Anmeldephase" />
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={deLocale}>
                    <Grid container direction={'row'}>
                      <DatePicker label="Datum 1 (Start Phase 2)" value={this.state.date1 === undefined ? moment(this.props.server_settings.date1, 'DD.MM.YYYY') : this.state.date1} onChange={(date) => this.handleDateChange(date, "date1")} cancelLabel="Abbrechen" okLabel="OK" invalidLabel="Ungültige Eingabe" format="dd.MM.yyyy" style={{ marginLeft: 33, width: 180, marginRight: "2%" }} ref={node => { this.picker = node; }} />
                      <DatePicker label="Datum 2 (Ende Phase 2)" value={this.state.date2 === undefined ? moment(this.props.server_settings.date2, 'DD.MM.YYYY') : this.state.date2} onChange={(date) => this.handleDateChange(date, "date2")} cancelLabel="Abbrechen" okLabel="OK" invalidLabel="Ungültige Eingabe" format="dd.MM.yyyy" style={{ width: 180 }} ref={node => { this.picker = node; }} />
                    </Grid>
                  </MuiPickersUtilsProvider>
                  <FormControlLabel value={3} control={<Radio checked={this.state.new_state === 0 ? this.props.server_settings.state_right === 3 : this.state.new_state === 3} onClick={() => this.changeState(3)} />} label="Phase 3: Pause (Rechnungen erstellen)" />
                  <TextField label="Anzeigetext Phase 3 (<date3> bzw. <date4> als Platzhalter für Datum)" multiline rowsMax="4" defaultValue={this.state.state_3_message === undefined ? this.props.server_settings.state_3_message : this.state.state_3_message} onChange={this.handleChange('state_3_message')} style={{ marginLeft: 33 }} />
                  <FormControlLabel value={4} control={<Radio checked={this.state.new_state === 0 ? this.props.server_settings.state_right === 4 : this.state.new_state === 4} onClick={() => this.changeState(4)} />} label="Phase 4: Zweite Anmeldephase (Nachmelden)" />
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={deLocale}>
                    <Grid container direction={'row'}>
                      <DatePicker label="Datum 3 (Start Phase 4)" value={this.state.date3 === undefined ? moment(this.props.server_settings.date3, 'DD.MM.YYYY') : this.state.date3} onChange={(date) => this.handleDateChange(date, "date3")} cancelLabel="Abbrechen" okLabel="OK" invalidLabel="Ungültige Eingabe" format="dd.MM.yyyy" style={{ marginLeft: 33, width: 180, marginRight: "2%" }} ref={node => { this.picker = node; }} />
                      <DatePicker label="Datum 4 (Ende Phase 4)" value={this.state.date4 === undefined ? moment(this.props.server_settings.date4, 'DD.MM.YYYY') : this.state.date4} onChange={(date) => this.handleDateChange(date, "date4")} cancelLabel="Abbrechen" okLabel="OK" invalidLabel="Ungültige Eingabe" format="dd.MM.yyyy" style={{ width: 180 }} ref={node => { this.picker = node; }} />
                    </Grid>
                  </MuiPickersUtilsProvider>
                  <FormControlLabel value={5} control={<Radio checked={this.state.new_state === 0 ? this.props.server_settings.state_right === 5 : this.state.new_state === 5} onClick={() => this.changeState(5)} />} label="Phase 5: Anmeldung abgeschlossen (Lesezugriff)" />
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={deLocale}>
                    <Grid container direction={'row'}>
                      <DatePicker label="Datum 5 (Ende Phase 5)" value={this.state.date5 === undefined ? moment(this.props.server_settings.date5, 'DD.MM.YYYY') : this.state.date5} onChange={(date) => this.handleDateChange(date, "date5")} cancelLabel="Abbrechen" okLabel="OK" invalidLabel="Ungültige Eingabe" format="dd.MM.yyyy" style={{ marginLeft: 33, width: 180, marginRight: "2%" }} ref={node => { this.picker = node; }} />
                    </Grid>
                  </MuiPickersUtilsProvider>
                  <FormControlLabel value={6} control={<Radio checked={this.state.new_state === 0 ? this.props.server_settings.state_right === 6 : this.state.new_state === 6} onClick={() => this.changeState(6)} />} label="Phase 6: Nicht mehr aktiviert" />
                  <TextField label="Anzeigetext Phase 6" multiline rowsMax="4" defaultValue={this.state.state_6_message === undefined ? this.props.server_settings.state_6_message : this.state.state_6_message} onChange={this.handleChange('state_6_message')} style={{ marginLeft: 33 }} />
                </RadioGroup>
              </div>
            </Scrollbars>
          </div>
          <div style={{ position: "absolute", top: 0, bottom: 65, right: 0, left: "50.2%", background: "white", opacity: 0.6 }}>
            <Scrollbars style={{ position: "absolute", bottom: 65, top: 0, left: 0, right: 0 }}>
              <div style={{ padding: 20 }}>
                <Typography align="center" variant="h6">{"Android-App"}</Typography>
                <RadioGroup value={this.state.new_app_state}>
                  <FormControlLabel value={1} control={<Radio checked={this.state.new_app_state === 0 ? this.props.server_settings.state_app === 1 : this.state.new_app_state === 1} onClick={() => this.changeAppState(1)} />} label="Phase 1: Noch nicht aktiviert" />
                  <TextField label="Anzeigetext Phase 1 (<date1> bzw. <date2> als Platzhalter für Datum)" multiline rowsMax="4" defaultValue={this.state.state_app_1_message === undefined ? this.props.server_settings.state_app_1_message : this.state.state_app_1_message} onChange={this.handleChange('state_app_1_message')} style={{ marginLeft: 33 }} />
                  <FormControlLabel value={2} control={<Radio checked={this.state.new_app_state === 0 ? this.props.server_settings.state_app === 2 : this.state.new_app_state === 2} onClick={() => this.changeAppState(2)} />} label="Phase 2: Erste Anmeldephase" />
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={deLocale}>
                    <Grid container direction={'row'}>
                      <DatePicker label="Datum 1 (Start Phase 2)" value={this.state.date1_app === undefined ? moment(this.props.server_settings.date1_app, 'DD.MM.YYYY') : this.state.date1_app} onChange={(date) => this.handleDateChange(date, "date1_app")} cancelLabel="Abbrechen" okLabel="OK" invalidLabel="Ungültige Eingabe" format="dd.MM.yyyy" style={{ marginLeft: 33, width: 180, marginRight: "2%" }} ref={node => { this.picker = node; }} />
                      <DatePicker label="Datum 2 (Ende Phase 2)" value={this.state.date2_app === undefined ? moment(this.props.server_settings.date2_app, 'DD.MM.YYYY') : this.state.date2_app} onChange={(date) => this.handleDateChange(date, "date2_app")} cancelLabel="Abbrechen" okLabel="OK" invalidLabel="Ungültige Eingabe" format="dd.MM.yyyy" style={{ width: 180 }} ref={node => { this.picker = node; }} />
                    </Grid>
                  </MuiPickersUtilsProvider>
                  <FormControlLabel value={3} control={<Radio checked={this.state.new_app_state === 0 ? this.props.server_settings.state_app === 3 : this.state.new_app_state === 3} onClick={() => this.changeAppState(3)} />} label="Phase 3: Pause (Rechnungen erstellen)" />
                  <TextField label="Anzeigetext Phase 3 (<date3> bzw. <date4> als Platzhalter für Datum)" multiline rowsMax="4" defaultValue={this.state.state_app_3_message === undefined ? this.props.server_settings.state_app_3_message : this.state.state_app_3_message} onChange={this.handleChange('state_app_3_message')} style={{ marginLeft: 33 }} />
                  <FormControlLabel value={4} control={<Radio checked={this.state.new_app_state === 0 ? this.props.server_settings.state_app === 4 : this.state.new_app_state === 4} onClick={() => this.changeAppState(4)} />} label="Phase 4: Zweite Anmeldephase (Nachmelden)" />
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={deLocale}>
                    <Grid container direction={'row'}>
                      <DatePicker label="Datum 3 (Start Phase 4)" value={this.state.date3_app === undefined ? moment(this.props.server_settings.date3_app, 'DD.MM.YYYY') : this.state.date3_app} onChange={(date) => this.handleDateChange(date, "date3_app")} cancelLabel="Abbrechen" okLabel="OK" invalidLabel="Ungültige Eingabe" format="dd.MM.yyyy" style={{ marginLeft: 33, width: 180, marginRight: "2%" }} ref={node => { this.picker = node; }} />
                      <DatePicker label="Datum 4 (Ende Phase 4)" value={this.state.date4_app === undefined ? moment(this.props.server_settings.date4_app, 'DD.MM.YYYY') : this.state.date4_app} onChange={(date) => this.handleDateChange(date, "date4_app")} cancelLabel="Abbrechen" okLabel="OK" invalidLabel="Ungültige Eingabe" format="dd.MM.yyyy" style={{ width: 180 }} ref={node => { this.picker = node; }} />
                    </Grid>
                  </MuiPickersUtilsProvider>
                  <FormControlLabel value={5} control={<Radio checked={this.state.new_app_state === 0 ? this.props.server_settings.state_app === 5 : this.state.new_app_state === 5} onClick={() => this.changeAppState(5)} />} label="Phase 5: Anmeldung abgeschlossen (Lesezugriff)" />
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={deLocale}>
                    <Grid container direction={'row'}>
                      <DatePicker label="Datum 5 (Ende Phase 5)" value={this.state.date5_app === undefined ? moment(this.props.server_settings.date5_app, 'DD.MM.YYYY') : this.state.date5_app} onChange={(date) => this.handleDateChange(date, "date5_app")} cancelLabel="Abbrechen" okLabel="OK" invalidLabel="Ungültige Eingabe" format="dd.MM.yyyy" style={{ marginLeft: 33, width: 180, marginRight: "2%" }} ref={node => { this.picker = node; }} />
                    </Grid>
                  </MuiPickersUtilsProvider>
                  <FormControlLabel value={6} control={<Radio checked={this.state.new_app_state === 0 ? this.props.server_settings.state_app === 6 : this.state.new_app_state === 6} onClick={() => this.changeAppState(6)} />} label="Phase 6: Nicht mehr aktiviert" />
                  <TextField label="Anzeigetext Phase 6" multiline rowsMax="4" defaultValue={this.state.state_app_6_message === undefined ? this.props.server_settings.state_app_6_message : this.state.state_app_6_message} onChange={this.handleChange('state_app_6_message')} style={{ marginLeft: 33 }} />
                </RadioGroup>
              </div>
            </Scrollbars>
          </div>
          {/* Leiste */}
          <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 65, background: "grey", opacity: 0.6 }}>
            <Link target="_blank" href={"https://formulare-schemmerhofen.de/" + Constants.FRONTEND_SUB + "/import.php"} style={{ position: "absolute", bottom: 25, left: 20, color: "white" }}>Access 2 Web</Link>
            <Link target="_blank" href={"https://formulare-schemmerhofen.de/" + Constants.FRONTEND_SUB + "/export.php"} style={{ position: "absolute", bottom: 25, left: 160, color: "white" }}>Web 2 Access</Link>
            <Typography variant="subtitle1" style={{ position: "absolute", marginLeft: 320, marginTop: 17 }}>Zahlungsziel:</Typography>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={deLocale}>
              <DatePicker value={this.state.payment_date === undefined ? moment(this.props.server_settings.payment_date, 'DD.MM.YYYY') : this.state.payment_date} onChange={(date) => this.handleDateChange(date, "payment_date")} cancelLabel="Abbrechen" okLabel="OK" invalidLabel="Ungültige Eingabe" format="dd.MM.yyyy" style={{ position: "absolute", marginLeft: 430, marginTop: 15, width: 90, marginRight: "2%" }} ref={node => { this.picker = node; }} />
            </MuiPickersUtilsProvider>
            <Fab variant="extended" color="secondary" style={{ position: "absolute", bottom: 10, right: 10 }} disabled={this.state.publishing} onClick={() => this.saveChangings()}><PublishIcon style={{ marginRight: 10 }} />
              {"Änderungen veröffentlichen"}
              {this.state.publishing && <CircularProgress size={24} className={classes.buttonProgress} />}
            </Fab>
          </div>
        </div>}
        {/* Alle Programme */}
        <Tabs value={this.state.selected_tab} onChange={this.handleTabChange} indicatorColor="secondary" textColor="secondary" variant="fullWidth" style={{ position: "absolute", right: 0, width: "40%", top: 90, backgroundColor: "#FFF", opacity: 0.6 }} >
          <Tab label="Alle Programme" />
          <Tab label="Alle Leiter" />
        </Tabs>
        <SwipeableViews axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'} index={this.state.selected_tab} onChangeIndex={this.handleTabChangeIndex} style={{ position: "absolute", right: 0, width: "calc(40%)", top: 140, height: "calc(100% - 180px)" }}>
          <div style={{ height: "calc(100vh - 180px)" }}>
            <Scrollbars style={{ position: "absolute", width: "100%", top: 0, bottom: 0 }}>
              {this.state.program_data.map(program => (
                <Fragment>
                  {(program.event.toLowerCase().includes(this.props.searchString.toLowerCase()) || program.year_ai.toString().includes(this.props.searchString) || program.city.toLowerCase().includes(this.props.searchString.toLowerCase())) && program.date_from.includes(new Date().getFullYear().toString()) && <ExpansionPanel expanded={this.state.expanded === program.id.toString()} onChange={this.handlePanelChange(program.id.toString())} style={{ borderRadius: 7, margin: 5, marginRight: 10 }}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography className={classes.heading} align="left" style={{ marginRight: this.props.userData.role === "administrator" ? 205 : 155 }}>{program.year_ai + ". " + program.event}</Typography>
                      <Typography className={classes.secondaryHeading} align="right">{moment(program.date_from, "DD.MM.YYYY").toDate().toLocaleDateString('de-DE', { weekday: 'short' }) + ". " + program.date_from.substring(0, 6) + (program.time_from !== "" ? " " + program.time_from : "")}</Typography>
                      {this.props.userData.role === "administrator" && <Typography className={classes.terciaryHeading} align="right" style={{ color: this.getColorForParticipants(parseInt(program.current_participants), parseInt(program.participants)), marginRight: 30 }}>{program.current_participants + " / " + program.participants}</Typography>}
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <Typography align="left">{"Termin: " + moment(program.date_from, "DD.MM.YYYY").toDate().toLocaleDateString('de-DE', { weekday: 'long' }) + " " + program.date_from + (program.date_to !== program.date_from ? " - " + program.date_to : "") + (program.time_from !== "" ? " von " + program.time_from + " bis " + program.time_to : "")}</Typography>
                        <Typography align="left">{"Treffpunkt: " + program.location}</Typography>
                        <Typography align="left">{"Leiter/in: " + program.first_name + " " + program.last_name + ", " + program.department}</Typography>
                        <Typography align="left">Kontakt: <Link href={"mailto:" + program.email}>{program.email}</Link> / <Link href={"tel:" + program.tel}>{program.tel}</Link></Typography>
                        {program.cl_first_name !== "" && <Typography align="left">{"Co-Leiter/in: " + program.cl_first_name + " " + program.cl_last_name}</Typography>}
                        {program.cl_first_name !== "" && <Typography align="left">Kontakt: <Link href={"mailto:" + program.cl_email}>{program.cl_email}</Link> / <Link href={"tel:" + program.cl_tel}>{program.cl_tel}</Link></Typography>}
                        <Typography align="left">{"Kosten: " + (program.price === "0" ? "kostenlos" : parseFloat(program.price).toFixed(2).replace(".", ",") + " €")}</Typography>
                        {(program.age_min !== "0" || program.age_max !== "0") && <Typography align="left">{"Alter: " + (program.age_max === "0" ? "ab " + program.age_min + " Jahren" : program.age_min + " - " + program.age_max + " Jahre")}</Typography>}

                        <Typography align="left" style={{ color: theme.palette.text.secondary, marginTop: 10, whiteSpace: "pre-line" }}>{program.description.split(" ^ ").join("\n").split("^").join("\n")}</Typography>

                        {this.state.selected_child !== null && <Tooltip title={this.props.server_settings.state === 5 ? "Keine Anmeldungen mehr möglich" : this.state.selected_child.first_name + " zu diesem Programm anmelden"} placement="top"><span><Button variant="outlined" onClick={() => this.addToWishlist(program.id, 1)} style={{ marginTop: 10 }} disabled={this.state.loading || this.props.server_settings.state === 5 || this.hasTimeOverlap(program) !== false} color="primary">
                          {this.state.selected_child.first_name + " anmelden"}
                          {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                        </Button></span></Tooltip>}

                        {this.state.selected_child !== null && program.additional_info && <Tooltip title={"Zusätzliche Infos einsehen"} placement="top"><span><Button variant="outlined" href={"https://formulare-schemmerhofen.de/files/fepro/info_" + program.year_ai + ".pdf"} target="blank" style={{ marginTop: 10, marginLeft: 10 }} disabled={this.state.loading} color="primary">
                          {"Zusätzliche Infos"}
                        </Button></span></Tooltip>}

                        {this.hasTimeOverlap(program) !== false && <Typography align="left" style={{ color: "red" }}>{"Dieses Programm überschneidet sich mit einem bereits gewählten Programm."}</Typography>}
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>}
                </Fragment>
              ))}
            </Scrollbars>
          </div>
          <div style={{ height: "calc(100vh - 180px)" }}>
            <Scrollbars style={{ height: "calc(100vh - 245px)" }}>
              {this.state.leader_data.map(leader => (
                <Fragment>
                  {(leader.first_name.toLowerCase().includes(this.props.searchString.toLowerCase()) || leader.last_name.toString().includes(this.props.searchString)) && <ExpansionPanel expanded={this.state.expanded === leader.id.toString()} onChange={this.handlePanelChange(leader.id.toString())} style={{ borderRadius: 7, margin: 5, marginRight: 10 }}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography className={classes.heading} align="left" style={{ color: (leader.program_count > 0 ? "#444" : "#BBB") }}>{leader.first_name + " " + leader.last_name}</Typography>
                      {<Typography className={classes.secondaryHeading} align="right" style={{ color: (leader.program_count > 0 ? "#444" : "#BBB") }}>{leader.program_count + (leader.program_count === "1" ? " Programm" : " Programme")}</Typography>}
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <Typography align="left">E-Mail: <Link href={"mailto:" + leader.email}>{leader.email}</Link></Typography>
                        <Typography align="left">Telefonnummer: <Link href={"tel:" + leader.tel}>{leader.tel}</Link></Typography>
                        <Typography align="left">{"Abteilung: " + leader.department}</Typography>
                        <Typography align="left">{"Zuletzt im Leiterportal angemeldet: " + (leader.last_login === "0" ? "Nie" : moment.unix(leader.last_login).format("DD.MM.YYYY HH:mm:ss"))}</Typography>
                        {this.state.all_program_data.map(program => (
                          <Fragment>{parseInt(program.leader_id) === parseInt(leader.id) && <Button variant="outlined" color="secondary" onClick={() => this.jumpToProgram(program.id)} style={{ marginRight: 5, marginTop: 10 }}>{program.event}</Button>}</Fragment>
                        ))}
                        <br />
                        {leader.program_count === "0" && <Button variant="outlined" color="primary" onClick={() => this.deleteLeader(leader)} style={{ marginTop: -5 }}>Leiter löschen</Button>}
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>}
                </Fragment>
              ))}
            </Scrollbars>
            {/* Leiste */}
            <div style={{ width: "100%", height: 65, background: "grey", opacity: 0.6 }}>
              <Fab variant="extended" color="secondary" style={{ marginTop: 7, marginLeft: 10 }} onClick={this.createLeader}><PersonAdd style={{ marginRight: 10 }} />Leiter erstellen</Fab>
            </div>
          </div>
        </SwipeableViews>

        {this.state.selected_child === null && this.state.all_program_data.length === 0 && (<Paper style={{ position: 'absolute', left: 'calc(80%)', top: '50%', padding: 10, transform: 'translate(-50%, -50%)' }} elevation={1}><Typography variant="subtitle1">{"Keine Programme verfügbar"}</Typography></Paper>)}
        {this.state.selected_child !== null && this.state.program_data.length === 0 && (<Paper style={{ position: 'absolute', left: 'calc(80%)', top: '50%', padding: 10, transform: 'translate(-50%, -50%)' }} elevation={1}><Typography variant="subtitle1">{"Keine weiteren Programme für " + this.state.selected_child.first_name + " verfügbar"}</Typography></Paper>)}
        {/* AddLeaderDialog */}
        {this.props.userData !== null && <AddLeaderDialog open={this.state.dialog_create_leader_open} onClose={this.onCreatedLeader} />}
        {/* DeleteLeaderDialog */}
        {this.props.userData !== null && this.state.selected_leader && <DeleteLeaderDialog open={this.state.dialog_delete_leader_open} onClose={this.onDeletedLeader} leader={this.state.selected_leader} />}

        {/* Success-Snackbar */}
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackbar_success_open} autoHideDuration={3000} onClose={this.handleSnackbarClose}>
          <SnackbarContent
            message={
              <span className={classes.message}>{this.state.snackbar_message}</span>
            }
            action={[
              <IconButton color="inherit" key="close" onClick={this.handleSnackbarClose}>
                <CloseIcon style={{ fontSize: 20 }} />
              </IconButton>
            ]}
            style={{ backgroundColor: green[600] }} />
        </Snackbar>
        {/* Error-Snackbar */}
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackbar_open} autoHideDuration={3000} onClose={this.handleSnackbarClose}>
          <SnackbarContent
            message={
              <span className={classes.message}><ErrorIcon className={classes.icon} />{this.state.snackbar_message}</span>
            }
            action={[
              <IconButton color="inherit" key="close" onClick={this.handleSnackbarClose}>
                <CloseIcon style={{ fontSize: 20 }} />
              </IconButton>,
            ]}
            style={{ backgroundColor: red[600] }} />
        </Snackbar>
      </Fragment>
    );
  }
}

AdministrationAdmin.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
  server_settings: PropTypes.object.isRequired,
  ikey: PropTypes.string,
  searchString: PropTypes.string.isRequired,
};

export default withStyles(styles, { withTheme: true })(AdministrationAdmin);
